import React from 'react';
import { connect } from 'react-redux';
import { registerUser } from '../redux/actions/users';
import { useState } from 'react';
import Authentication from '../components/Authentication';

function Register(props) {
  const [username, setUsername] = useState(props.username);
  const [email, setEmail] = useState(props.email);
  const [password, setPassword] = useState(props.password);

  const { registerUser } = props;

  const handleRegister = (e) => {
    e.preventDefault();

    const data = {
      username,
      email,
      password
    };

    registerUser(data);
    setUsername(' ');
  };
  return (
    <div>
      <Authentication
        question="Sudah Punya Akun?"
        auth="Login Saja"
        link="/login"
        text1="Buat Akun"
        text2="Buat akun dan mulai berontribusi untuk membangun Tegal yang lebih lebih baik"
        text3="Buat Akun"
        onInputUsername={(e) => setUsername(e.target.value)}
        onInputEmail={(e) => setEmail(e.target.value)}
        onInputPassword={(e) => setPassword(e.target.value)}
        onSubmit={handleRegister}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  username: state.users.username,
  email: state.users.email,
  password: state.users.password
});

const mapDispatchToProps = (dispatch) => ({
  registerUser: (data) => dispatch(registerUser(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
